<template>
  <div>
    <TopWszechDesktop v-if="window"/>
    <TopWszechMobile v-else/>
  </div>
</template>

<script>
import TopWszechDesktop from './Desktop/TopWszech.vue';
import TopWszechMobile from './Mobile/TopWszech.vue';

export default {
  components: {
    TopWszechDesktop,
    TopWszechMobile
  },
  data() {
    return {
      windowWidth: window.innerWidth
    }
  },
  computed: {
    window() {
      return this.windowWidth > 991;
    }
  },
  watch:{
  },
  mounted() {
    window.addEventListener('resize', () => {
     this.windowWidth = window.innerWidth;
   })
  }
}
</script>

<style lang="scss" scoped>
  .artist {
    &__menu {
      margin-top: -17rem;
    }
  }
</style>
